import React, { useState } from "react";
import "./App.css";
import "./play-along-container.css";
import PlayAlong from "./PlayAlong";
import Counter from "./counter";
import { RhythmImplResolved } from "./rhythms/rhythm-types";
import { rhythms } from "./rhythms/all-rhythms";
import { Dropdown, DropdownOption } from "./dropdown";
import { compositions } from "./compositions/all-compositions";
import { YoutubeVideo } from "./YoutubeVideo";

function PlayAlongContainer() {
    const [comp, changeComp] = useState(Object.values(compositions)[0].id);
    const dropdownOptions: DropdownOption[] = Object.values(compositions).map(
        (c) => ({
            id: c.id,
            displayName: c.displayName,
        })
    );
    const composition = compositions[comp];
    if (composition === undefined) return null;

    let media = (
        <>
            <p>Taals used: {composition.taals.join(",")}</p>
            <YoutubeVideo
                videoId={composition.media.youtubeVideoId}
                onTimeUpdate={(_) => {}}
            />
        </>
    );

    if (composition.rhythmSpec !== undefined) {
        const counter = new Counter(composition.rhythmSpec.rhythmPortions);
        const rhythmImplResolved: RhythmImplResolved = {
            spec: composition.rhythmSpec,
            impl: composition.rhythmSpec.rhythmPortions.map((p) => {
                const matching = Object.values(rhythms).find(
                    (r) => r.beatsPerCycle === p.beatsPerCycle
                );
                if (matching === undefined) {
                    throw new Error("no matching rhythm");
                }
                return matching;
            }),
        };
        media = (
            <PlayAlong
                videoId={composition.media.youtubeVideoId}
                counter={counter}
                rhythm={rhythmImplResolved}
            ></PlayAlong>
        );
    }

    return (
        <div className="play-along-container">
            <Dropdown
                options={dropdownOptions}
                label="composition"
                onOptionChanged={changeComp}
            />
            {media}
        </div>
    );
}

export default PlayAlongContainer;
